/* ======================================================= */
/*                        WORKSHOP MENU                    */
/* ======================================================= */

//wks menu plugin

export function wsMenu () {

		//define option defaults
		let defaults = {
			target: '.ws_menu',
			addClassNames: false,
			changeToDesktop: "all and (min-width: 1100px)",
			megaMenu: false,
			squareDropdownButtons: false,
			hover: false,
		}

		//recurring classes
		this.Elements = {
			container: "ws_menu__inner",
			list: "ws_menu__list",
			item: "ws_menu__item",
			btn: "ws_menu__dropdown_btn",
			link: "ws_menu__link",
			mobile: "ws_menu--mobile",
			desktop: "ws_menu--desktop",
			mega: "ws_menu--megamenu",
		}

		//classnames assigned by the plugin (optional)
		this.ClassNames = {
			tierZero: "ws_menu__list--tier_zero",
			tierOne: "ws_menu__list--tier_one",
			tierTwo: "ws_menu__list--tier_two",
			tierThree: "ws_menu__list--tier_three",
			mega: "ws_menu__list--tier_mega",
			activeClass: "active",
			grid: "ws_menu__item--grid",
			fullWidthLink: "ws_menu__item--full_width_link",
			list: "ws_menu__item--list",
		}

		// Create options by extending defaults with the passed in arugments
		if (arguments[0] && typeof arguments[0] === 'object') {
			this.options = extendDefaults(defaults, arguments[0]);
		}

    /** @param {HTMLElement} target **/
		let target = document.querySelector(this.options.target);

    // global element references
		this.target = target;
		this.slideUpTimeout;
		this.slideDownTimeout;


		//
		//CALL METHODS
		//

		this.init(target);

	}

	//
	//PUBLIC METHODS
	//

	wsMenu.prototype.init = function (target) {

		var subnavs = target.querySelectorAll(`.${this.Elements.item} > .${this.Elements.list}`),
      numOfSubnavs = subnavs.length;

		for (var i = 0; i < numOfSubnavs; i++) {
			subnavs[i].setAttribute("aria-expanded", "false");
		}

		if (this.options.addClassNames && !this.options.megaMenu) {
			this.addClassNames(target);
		}

		if (this.options.megaMenu) {
			this.megaMenu(target);
		}

		this.changeToDesktop();
		this.addParentClassNames(target);

		if(this.options.squareDropdownButtons) {
			this.squareDropdownButtons(target);
		}

		if (this.options.hover) {
			this.onEvent(target, true);
		} else {
			this.onEvent(target, false );
		}
	}


	wsMenu.prototype.addClassNames = function (target) {

		var _this = this;
		var tier = {
			zero: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list}`), _this.ClassNames.tierZero],
			one: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.tierOne],
			two: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.tierTwo],
			three: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.tierThree],
		}

		var key;
		for (key in tier) {

			var i;
			for (i = 0; i < tier[key][0].length; i++) {
				tier[key][0][i].classList.add(tier[key][1]);
			}
		}

		var number;
		for (number in tier) {
			var tierList = target.querySelectorAll(`.ws_menu__list--tier_${number}`);

			//add tier number to the child item of the list--tier_X
			tierList.forEach(function (a) {

				var tierListChildren = [].slice.call(a.children);
				tierListChildren.forEach(function (b) {

					if (b.tagName !== "UL") {
						b.classList.add(`tier_${number}`);
					}

					var tierListGrandChildren = [].slice.call(b.children);
					tierListGrandChildren.forEach(function (c) {
						if (c.tagName !== "UL") {
							c.classList.add(`tier_${number}`);
						}
					});
				});
			});

			var k;
			for (k = 0; k < tierList.length; k++) {
				var tierItems = tierList[k];
			}
		}
	}

	wsMenu.prototype.megaMenu = function (target) {

		var _this = this;
		var tier = {
			zero: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list}`), _this.ClassNames.tierZero],
			one: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.tierOne],
			mega: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.mega],
			two: [target.querySelectorAll(`.${_this.Elements.container} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list} > .${_this.Elements.item} > .${_this.Elements.list}`), _this.ClassNames.tierTwo],
		}

		//add overall mega menu class to the first ancestor of the menu
		if (!target.classList.contains(_this.Elements.mega)) {
			target.classList.add(_this.Elements.mega);
		}

		var key;
		for (key in tier) {

			var i;
			for (i = 0; i < tier[key][0].length; i++) {
				tier[key][0][i].classList.add(tier[key][1]);
			}
		}

		var number;
		for (number in tier) {
			var tierList = target.querySelectorAll(`.ws_menu__list--tier_${number}`);

			//add tier number to the child item of the list--tier_X
			tierList.forEach(function (a) {

				var tierListChildren = [].slice.call(a.children);
				tierListChildren.forEach(function (b) {

					if (b.tagName !== "UL") {
						b.classList.add(`tier_${number}`);
					}

					var tierListGrandChildren = [].slice.call(b.children);
					tierListGrandChildren.forEach(function (c) {
						if (c.tagName !== "UL") {
							c.classList.add(`tier_${number}`);
						}
					});
				});
			});

			var k;
			for (k = 0; k < tierList.length; k++) {
				var tierItems = tierList[k];
			}
		}

		//add grid and full width classes to index 0 & 1 tier_mega elements in mega tier lists
		var tierMegaLists = target.querySelectorAll(".ws_menu__list--tier_mega");

		if(tierMegaLists) {
			tierMegaLists.forEach(function (elem) {
				var tierMegaElems = elem.querySelectorAll(".ws_menu__item.tier_mega");
				var l;

				for (l = 0; l < tierMegaElems.length; l++) {
					if (l == 0) {
						tierMegaElems[l].classList.add(_this.ClassNames.grid);
					} else if (l == 1){
						tierMegaElems[l].classList.add(_this.ClassNames.fullWidthLink);
					} else if (l == 2){
						tierMegaElems[l].classList.add(_this.ClassNames.list);
					}
				}
			});
		}
	}

	//DETECT
	wsMenu.prototype.addParentClassNames = function (target) {

		var menu_items = target.querySelectorAll("li");

		if (menu_items !== "undefined") {
			for (var i = 0; i < menu_items.length; i++) {
				var menu_items_children = menu_items[i].children;
				var submenuDetected = false;
				for (var j = 0; j < menu_items_children.length; j++) {
					if (menu_items_children[j].tagName == "UL") {
						submenuDetected = true;
					}
				}
				if (submenuDetected) {
					menu_items[i].classList.add("has_submenu");
				} else {
					menu_items[i].classList.add("empty");
				}
			}
		}
	}

	wsMenu.prototype.onEvent = function (target, isHover) {

		var _this = this;
    	var btns = target.querySelectorAll(`.${this.Elements.btn}`);
		var numOfbtns = btns.length;

		addEventListeners();

		function addEventListeners() {

			btns.forEach(function(btn){
				//if it's a hover menu, apply click events to
				if (isHover && !btn.classList.contains('tier_zero')) {
					btn.addEventListener("click", eventListener);
				} else if (isHover && btn.classList.contains('tier_zero')) {

					var item = btn.closest('.ws_menu__item.tier_zero');
					var wsHover = new VanillaSlideToggle();
					btn.addEventListener("click", eventListener);
					item.addEventListener('mouseenter', hoverEnter);
					item.addEventListener('mouseleave', hoverLeave);

					btn.addEventListener('keyup', (keypress) => {
						if (keypress.keyCode === 27 ){ //if ESC is pressed 
							closeSiblings(keypress);
						}
					});
					item.addEventListener('keyup', (keypress) => {
						if (keypress.keyCode === 27) { // if ESC is pressed
							closeSiblings(keypress);
						}
					});

					// WA - REMOVED, event listeners should be the same on all screen widths.
					// var hoverMQ = new VanillaMQ({
					// 	mediaQuery: _this.options.changeToDesktop,
					// 	matches: function() {

					// 		// remove click event listener when above 1200px
					// 		// if (btn.classList.contains('tier_zero')) {
					// 		// 	btn.removeEventListener('click', eventListener);
					// 		// }

					// 		//add hover states when above 1200px
					// 		item.addEventListener('mouseenter', hoverEnter);
					// 		item.addEventListener('mouseleave', hoverLeave);
					// 		// item.addEventListener('click', eventListener);
					// 		item.addEventListener('keyup', (event) => {
					// 			if (event.keyCode === 13 || event.keyCode === 49) {
					// 				eventListener(event);
					// 			}
					// 		});
					// 	},
					// 	unmatches: function() {

					// 		//add regular click listener when the screen is lower than 1200px
					// 		btn.addEventListener("click", eventListener);

					// 		//remove hover event listeners
					// 		if (btn.classList.contains('tier_zero')) {
					// 			item.removeEventListener('mouseenter', hoverEnter);
					// 		}
					// 		if (btn.classList.contains('tier_zero')) {
					// 			item.removeEventListener('mouseleave', hoverLeave);
					// 		}
					// 	}
					// })

					function hoverEnter(event) {
						var list = event.target.querySelector('.ws_menu__list.ws_menu__list--tier_one')
						wsHover.slideDown(list);

						if (!item.classList.contains('active')) {
							item.classList.add('active');
						}
					}

					function hoverLeave(event) {
						var list = event.target.querySelector('.ws_menu__list.ws_menu__list--tier_one')
						wsHover.slideUp(list);

						if (item.classList.contains('active')) {
							item.classList.remove('active');
						}
					}

				} else {
					btn.addEventListener("click", eventListener);
				}

				// event listener function, named so it can be removed if needed
				function eventListener(event) {
					var siblings = event.target.parentNode.children;
					var parent = event.target.parentNode;
					var parentSiblings = getSiblings(parent);
							siblings = [].slice.call(siblings);
					siblings.forEach(function(sibling){
						if (sibling.tagName.toLowerCase() == "ul") {
							console.log(sibling);
							if (!sibling.parentNode.classList.contains('tier_one')) {
								_this.slideToggle(sibling);
							} else {
								// Keyboard support for tier one dropdowns
								wsHover.slideToggle(sibling);
							}
						}
					});

					//close other same-tier menues
					var k;
					for (k = 0; k < parentSiblings.length; k++) {
						if (parentSiblings[k].classList.contains(_this.ClassNames.activeClass)) {
							_this.slideUp(parentSiblings[k].querySelector(`.${_this.Elements.list}`));
							parentSiblings[k].classList.remove(_this.ClassNames.activeClass);
						}
					}
				}		
				
				function closeSiblings(event) {
					var escTarget = event.target.parentElement;
					while (escTarget.tagName.toLowerCase() !== "ul") {
						escTarget = escTarget.parentElement;
					}
					if (!escTarget.parentElement.classList.contains("ws_menu__inner")) {
						wsHover.slideToggle(escTarget);
					}
				}
				
			});

		}

	}

	//////////////
	//vanilla slidetoggle - https://w3bits.com/javascript-slidetoggle/
	//////////////

		//(OPTIONAL) - MAKE DROPDOWN BUTTONS SQUARE
	wsMenu.prototype.squareDropdownButtons = function(target) {
			var dropdownButtonsArray = target.querySelectorAll(".ws_menu__dropdown_btn");
			var squareDropdownButtonsDebounce = debounce(function() {
				var i;
				for(i = 0; i < dropdownButtonsArray.length; i++) {
					dropdownButtonsArray[i].style.width = dropdownButtonsArray[i].offsetHeight + "px";
				}
			}, 200);

			window.addEventListener("resize", squareDropdownButtonsDebounce);
			window.addEventListener("DOMContentLoaded",  squareDropdownButtonsDebounce);
	}

	wsMenu.prototype.slideUp = function slideUp(target) {

		var listSibling = target.parentNode.querySelector(`.${this.Elements.list}`);
		var listParent = target.parentNode;
		listParent.classList.remove(this.ClassNames.activeClass);

		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;

		clearTimeout(this.slideDownTimeout);
		clearTimeout(this.slideUpTimeout);

		this.slideUpTimeout = setTimeout(function () {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	};

	wsMenu.prototype.slideDown = function slideDown(target) {

		var listSibling = target.parentNode.querySelector(`.${this.Elements.list}`);
		var listParent = target.parentNode;
		listParent.classList.add(this.ClassNames.activeClass);

		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		target.style.removeProperty('display');
		var display = window.getComputedStyle(target).display;
		if (display === 'none') display = 'block'; //modified
		target.style.display = display;
		var height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');

		clearTimeout(this.slideDownTimeout);
		clearTimeout(this.slideUpTimeout);

		this.slideDownTimeout = setTimeout(function () {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	};

	wsMenu.prototype.slideToggle = function slideToggle(target) {

		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

		if (window.getComputedStyle(target).display === 'none') {
			return this.slideDown(target, duration);
		} else {
			return this.slideUp(target, duration);
		}
	};

	//remove all event listeners
	wsMenu.prototype.rebuild = function() {
		var _this = this;
		var elClone = _this.target.cloneNode(true);
		_this.target.parentNode.replaceChild(elClone, _this.target);
	};

	//////////////
	//////////////


	wsMenu.prototype.changeToDesktop = function () {

		var _this = this;

		var x = window.matchMedia(_this.options.changeToDesktop);
		mq(x); // Call listener function at run time
		x.addListener(mq) // Attach listener function on state changes

		function mq(x) {
			if (x.matches) { // If media query matches
				document.querySelector(_this.options.target).classList.remove("ws_menu--mobile");
				document.querySelector(_this.options.target).classList.add("ws_menu--desktop");
			} else {
				document.querySelector(_this.options.target).classList.remove("ws_menu--desktop");
				document.querySelector(_this.options.target).classList.add("ws_menu--mobile");
			}
		}
	}

	//
	//PRIVATE METHODS
	//
	// Utility method to extend defaults with user options
	function extendDefaults(source, properties) {
		var property;
		for (property in properties) {
			if (properties.hasOwnProperty(property)) {
				source[property] = properties[property];
			}
		}
		return source;
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function throttle(func, wait, options) {
		var context, args, result;
		var timeout = null;
		var previous = 0;
		if (!options) options = {};
		var later = function () {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function () {
			var now = Date.now();
			if (!previous && options.leading === false) previous = now;
			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}
				previous = now;
				result = func.apply(context, args);
				if (!timeout) context = args = null;
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
			return result;
		};
	};

	function getChildren(n, skipMe) {
		var r = [];
		for (; n; n = n.nextSibling)
			if (n.nodeType == 1 && n != skipMe)
				r.push(n);
		return r;
	};

	function getSiblings(n) {
		return getChildren(n.parentNode.firstChild, n);
	}

	function VanillaSlideToggle() {

		var slideUpTimeout,
			slideDownTimeout;

		this.slideUp = function slideUp(target) {
			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;

			clearTimeout(slideDownTimeout);
			clearTimeout(slideUpTimeout);

			slideUpTimeout = window.setTimeout(function () {
				target.style.display = 'none';
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property'); //alert("!");
			}, duration);
		};

		this.slideDown = function slideDown(target) {
			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
			target.style.removeProperty('display');
			var display = window.getComputedStyle(target).display;
			if (display === 'none') display = 'block';
			target.style.display = display;
			var height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');

			clearTimeout(slideDownTimeout);
			clearTimeout(slideUpTimeout);

			slideDownTimeout = window.setTimeout(function () {
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		};

		this.slideToggle = function slideToggle(target) {
			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

			if (window.getComputedStyle(target).display === 'none') {
				return this.slideDown(target, duration);
			} else {
				return this.slideUp(target, duration);
			}
		};

		this.clearStyles = function (target) {
			target.removeAttribute('style');
		}
	};

	function VanillaMQ() {
		var _this = this;

		var defaults = {
			target: 'document',
			mediaQuery: 'all',
			matches: function matches() {
				console.log("Matched!");
			},
			unmatches: function unmatches() {
				console.log("Didn't match!");
			}
		};
		this.properties = {
			matched: false
		};
		this.options = {}; // Create options by extending defaults with the passed in arugments

		if (arguments[0] && typeof(arguments[0]) === 'object') {
			this.options = extendDefaults(defaults, arguments[0]);
		} // Private Methods

		function extendDefaults(source, properties) {
			var property;

			for (property in properties) {
				if (properties.hasOwnProperty(property)) {
					source[property] = properties[property];
				}
			}

			return source;
		}

		this.init = function () {
			_this.mq();

			window.matchMedia(_this.options.mediaQuery).addListener(_this.mq);
		};

		this.mq = function () {
			if (window.matchMedia(_this.options.mediaQuery).matches) {
				_this.options.matches();
			} else {
				_this.options.unmatches();
			}
		};

		this.init();
	}
